/* eslint
    no-async-promise-executor: "warn",
    dot-notation: "off"
*/

import { IDataMapper, IEasyfyEvent, IEasyfyEventExporter } from '@shared/easyfy.events/easyfy.eventdata';

/* Klaviyo Exporter class */
export class KlaviyoEventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;

  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (this.mapper) {
        const eventData = this.mapper.MapEventData(event);
        await this.PushToKlaviyo(eventData);
      }
      resolve();
    });
  }

  async PushToKlaviyo(klaviyoEvent: any): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (klaviyoEvent) {
        window['klaviyo'] = window?.['klaviyo'] || [];
        window['klaviyo'].push(["track", klaviyoEvent.event, klaviyoEvent.data]);

        // console.group('%c Klaviyo ', 'color: #bada55');
        // console.dir(window['klaviyo']);
        // console.groupEnd();
        resolve(true);
      }
      else {
        resolve(false);
      }
    });
  }
}
